import React, { ComponentProps, FC, ReactNode } from 'react';
import { Button } from '@wix/design-system';

import s from './AnimatedIconButton.scss';
import classNames from 'classnames';

type Props = {
  animatedIcon?: ReactNode;
} & ComponentProps<typeof Button>;

export const AnimatedIconButton: FC<Props> = (props) => {
  return (
    <Button
      {...props}
      className={classNames(
        props.className,
        s.root,
        s.withCustomPadding,
        s.withCustomBackgroundColor,
      )}
    >
      <span className={s.content}>
        {props.children}
        <span className={s.animatedIcon}>{props.animatedIcon}</span>
      </span>
    </Button>
  );
};
